import React, { PureComponent } from "react";
import { PropTypes } from "prop-types";
import { connect } from "react-redux";

import ValidationMessage from "./messages/ValidationMessage.jsx";

import { selectAllViolationErrors } from "../../state/reducers/api/apiSelectors.js";
import { selectLatestSuccesses } from "../../state/reducers/api/apiSelectors.js";
import { resetErrors } from "../../state/reducers/api/apiActions.js";
import { selectCopy } from "../../state/reducers/locale/copySelector.js";

function withBasicForm(WrappedComponent) {
  class WithBasicForm extends PureComponent {
    static propTypes = {
      isFetching: PropTypes.bool,
      isSuccess: PropTypes.bool,
      onCancel: PropTypes.func,
      onReset: PropTypes.func,
      onSubmit: PropTypes.func.isRequired,
      apiSuccesses: PropTypes.object,
      violationErrors: PropTypes.object,
      copy: PropTypes.func.isRequired
    };

    constructor(props) {
      super(props);

      this.state = {
        showMessages: false
      };
    }

    // -- HANDLERS -- //

    // triggered whenever the reset button is clicked
    onCancel = () => {
      const { onCancel } = this.props;
      this.setState({ showMessages: false });
      if (onCancel) onCancel();
    };

    onReset = () => {
      const { resetErrors, onReset } = this.props;
      this.setState({ showMessages: false });
      if (resetErrors) resetErrors();
      if (onReset) onReset();
    };

    onSubmit = () => {
      const { resetErrors } = this.props;
      if (resetErrors) resetErrors();
      this.setState({ showMessages: true });
    };

    // only triggered whenever the submit button is clicked and the form is valid
    onFormikSubmit = values => {
      // console.log("onFormikSubmit", values);
      this.props.onSubmit(values);
    };

    // required due to this issue
    // https://github.com/jaredpalmer/formik/issues/1133
    // fixed in formik v2 once it's stable
    isInitialValid = formikProps => {
      console.log("isInitialValid:", formikProps);
      if (!formikProps.validationSchema) return true;
      return formikProps.validationSchema.isValidSync(
        formikProps.initialValues
      );
    };

    // -- RENDER -- //

    // handling this outside of Formik as the message should be shown once submit has been clicked
    // not just on successfull Formik submission, or on failed validation check.
    renderMessage = (formikProps, copyKey) => {
      const { violationErrors, isFetching, isSuccess } = this.props;

      // can't rely on isValid for this as remove arrayHelper doesn't seem to clean up the errors object correctly
      const valid =
        violationErrors ||
        (Object.keys(formikProps.errors).length > 0 &&
          Object.keys(formikProps.touched).length > 0)
          ? false
          : true;

      if (this.state.showMessages === true && !valid && !isFetching) {
        return <ValidationMessage valid={valid} copyKey={copyKey} />;
      }

      return null;
    };

    render() {
      return (
        <WrappedComponent
          {...this.props}
          {...this.state}
          initDraft={this.initDraft}
          onCancel={this.onCancel}
          onReset={this.onReset}
          onSubmit={this.onSubmit}
          onFormikSubmit={this.onFormikSubmit}
          renderMessage={this.renderMessage}
          isInitialValid={this.isInitialValid}
        />
      );
    }
  }

  WithBasicForm.displayName = `WithBasicForm(${getDisplayName(
    WrappedComponent
  )})`;

  return connect(mapStateToProps, mapDispatchToProps)(WithBasicForm);
}

function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || "Component";
}

const mapStateToProps = state => ({
  apiSuccesses: selectLatestSuccesses(state),
  violationErrors: selectAllViolationErrors(state),
  copy: selectCopy(state)
});

const mapDispatchToProps = dispatch => ({
  resetErrors: () => dispatch(resetErrors())
});

export default withBasicForm;
